<div class="container">
    <mat-card appearance="outlined">
        <mat-card-title>
            <div style="text-align: center;font-weight:bold;">User Profile</div>
        </mat-card-title>
        <mat-card-subtitle></mat-card-subtitle>
        <mat-card-content>
            <div class="row">
                <div class="col-md-2" style="text-align: right;">
                    <span class="title">User Name:</span>
                </div>
                <div class="col-md-4" style="text-align: left;">
                    <span class="titleValue">{{userProfile.userName}}</span>
                </div>
                <div class="col-md-2" style="text-align: right;">
                    <span class="title">Role:</span>
                </div>
                <div class="col-md-4" style="text-align: left;">
                    <span class="titleValue">{{userProfile.roleName}}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-md-2" style="text-align: right;">
                    <span class="title">First Name:</span>
                </div>
                <div class="col-md-4" style="text-align: left;">
                    <span class="titleValue">{{userProfile.firstName}}</span>
                </div>
                <div class="col-md-2" style="text-align: right;">
                    <span class="title">Last Name:</span>
                </div>
                <div class="col-md-4" style="text-align: left;">
                    <span class="titleValue">{{userProfile.lastName}}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-md-2" style="text-align: right;">
                    <span class="title">Email :</span>
                </div>
                <div class="col-md-4" style="text-align: left;">
                    <span class="titleValue">{{userProfile.email}}</span>
                </div>
                <div class="col-md-2" style="text-align: right;">
                    <span class="title">Phone:</span>
                </div>
                <div class="col-md-4" style="text-align: left;">
                    <span class="titleValue">{{userProfile.phoneNumber}}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-md-2" style="text-align: right;">
                    <span class="title">State :</span>
                </div>
                <div class="col-md-4" style="text-align: left;">
                    <span class="titleValue">{{userProfile.state}}</span>
                </div>
                <div class="col-md-2" style="text-align: right;">
                    <span class="title">City:</span>
                </div>
                <div class="col-md-4" style="text-align: left;">
                    <span class="titleValue">{{userProfile.city}}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-md-2" style="text-align: right;">
                    <span class="title">EmployeeId:</span>
                </div>
                <div class="col-md-4" style="text-align: left;">
                    <span class="titleValue"> {{userProfile.employeeId}}</span>
                </div>
            </div>
        </mat-card-content>
        <div *ngIf="isLoaderResult"
            style="display:flex; justify-content:content; align-items:center; position:absolute; top:40%;left:35%">
            <mat-spinner color="warn"></mat-spinner>
        </div>
        <mat-card-footer>
            <div class="row action-btn justify-content-center">
                <div class="col-md-3">
                </div>
                <div class="col-md-6">
                    <button md-raised-button type="button" class="btn btn-round btn-block btn-rose"
                        (click)="close()">Close</button>
                </div>
                <div class="col-md-3">
                </div>
            </div>
        </mat-card-footer>
    </mat-card>
</div>